<template>

        <div v-if="deleted">
            <img :src="params?.images?.deleted" v-if="params?.images?.deleted" alt=Success>
            <div class='title'>
                {{params.local?.deletionConfirmationResponse}}
            </div>
            <div class="buttons">
                <button @click.prevent="closeModal" class="button mainButton">{{params.local?.closeButton}}</button>
            </div>
        </div>

        <div v-else>
            <div class='title'>
                {{params.local?.deletionConfirmation}}
            </div>
            <div class='text'>
                {{params.local?.deletionConfirmationText}}
            </div>
            <div class="buttons">
                <button @click.prevent="deleteLeads" class="button">{{params.local?.deletionConfirmationButton}}</button>
                <button @click.prevent="closeModal" class="button mainButton">{{params.local?.cancelButton}}</button>
            </div>
        </div>
</template>

<script setup>

import {ref} from "vue";
import {ajax, getCookie} from "@/assets/js/Functions"
import bus from '@/store/EventBus.js';

const deleted = ref(false);
const emit = defineEmits(['close'])
const props = defineProps({
    trigger: Object,
    params: Object,
});

const deleteLeads = () => {
    ajax({
        action: "delete_lead",
        lead_ids: props.params.leadId,
        client_auth: getCookie('client_auth')
    }, (response) => {
        if((response.status) === 'error'){
            alert(response.text)
        }else{
            bus.emit('updateLeads');
            deleted.value = true
        }
    })
}

const closeModal = () => {
    emit('close');
}

</script>